import {
  getPage,
  getDetail,
  getClientPage,
  exportExcel,
} from '@/api/samestopanalysisresultserv'

export default {
  state: {
    state_SamestopAnalysisResult_GetPageResult: null,
    state_SamestopAnalysisResult_GetDetailResult: null,
    state_SamestopAnalysisResult_GetClientPageResult: null,
    state_SamestopAnalysisResult_ExportExcelResult: null,
  },
  mutations: {
    SET_SAMESTOPANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_SamestopAnalysisResult_GetPageResult = rst;
    },
    SET_SAMESTOPANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_SamestopAnalysisResult_GetDetailResult = rst;
    },
    SET_SAMESTOPANALYSISRESULT_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_SamestopAnalysisResult_GetClientPageResult = rst;
    },
    SET_SAMESTOPANALYSISRESULT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_SamestopAnalysisResult_ExportExcelResult = rst;
    },
  },
  actions: {
    SamestopAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SAMESTOPANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SAMESTOPANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SamestopAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SAMESTOPANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SAMESTOPANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SamestopAnalysisResultServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SAMESTOPANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SAMESTOPANALYSISRESULT_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SamestopAnalysisResultServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SAMESTOPANALYSISRESULT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SAMESTOPANALYSISRESULT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_SamestopAnalysisResult_GetPageResult: state => {
      return state.state_SamestopAnalysisResult_GetPageResult;
    },
    get_SamestopAnalysisResult_GetDetailResult: state => {
      return state.state_SamestopAnalysisResult_GetDetailResult;
    },
    get_SamestopAnalysisResult_GetClientPageResult: state => {
      return state.state_SamestopAnalysisResult_GetClientPageResult;
    },
    get_SamestopAnalysisResult_ExportExcelResult: state => {
      return state.state_SamestopAnalysisResult_ExportExcelResult;
    },
  }
}